import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { arrange, asc, groupBy, tidy } from '@tidyjs/tidy';
import { RiskByGroup } from './RiskRelatedCheckboxList';
import { INFO_CATEGORY_RISK_RELATED } from '@Domains/RiskRelated';
import { RelateRisksWithCategory } from '../ChanceOfRisk';

const mappingRiskLabel = (group: INFO_CATEGORY_RISK_RELATED) => {
  switch (group) {
    case INFO_CATEGORY_RISK_RELATED.STRATEGIC_RISK:
      return 'ความเสี่ยงด้านกลยุทธ์และการประกอบธุรกิจ (Strategic Risk)';
    case INFO_CATEGORY_RISK_RELATED.OPERATIONAL_RISK:
      return 'ความเสี่ยงด้านการบริหารจัดการและการปฏิบัติงาน (Operational Risk)';
    case INFO_CATEGORY_RISK_RELATED.COMPLIANCE_RISK:
      return 'ความเสี่ยงด้านกฎระเบียบและกฎหมาย (Compliance Risk)';
    case INFO_CATEGORY_RISK_RELATED.FINANCIAL_RISK:
      return 'ความเสี่ยงด้านการเงิน (Financial Risk)';
    default:
      return;
  }
};

export const mapRiskByGroups = (risks: IInfoCategoryMasterData[]) => {
  const riskGroups = tidy(
    risks,
    arrange(
      (currentItem, nextItem) => currentItem.sequence - nextItem.sequence
    ),
    groupBy('infoCategory', (group) => [
      {
        value: group[0].infoCategory,
        label: mappingRiskLabel(
          group[0].infoCategory as INFO_CATEGORY_RISK_RELATED
        ),
        data: [...group],
      } as RiskByGroup,
    ])
  );

  return riskGroups;
};

export const mapRiskByGroupsToUIDisplay = (
  risks: RelateRisksWithCategory[]
) => {
  const riskGroups = tidy(
    risks,
    arrange([asc('sequence')]),
    groupBy('infoCategory', (group) => [
      {
        value: group[0].infoCategory,
        label: mappingRiskLabel(
          group[0].infoCategory as INFO_CATEGORY_RISK_RELATED
        ),
        data: [...group],
      } as RiskByGroup,
    ])
  );

  return riskGroups;
};
